import {SharedQuestion} from "./SharedQuestion";

export class RadioGridSharedQuestion extends SharedQuestion {

    protected values:IValue[] = [];

    public question:IQuestion;

    isValid():boolean {
        super.isValid();

        if (!this.question.required) {
            return true;
        }

        return this.question.meta.rows && this.question.meta.rows.length === this.values.length;
    }

    validationMessage():string {
        var message = this.getMessage('required');
        if (message) {
            return message;
        }

        return 'radio_grid_validation_message';
    }

    getValue():IValue[] {
        return this.values;
    }

    setValue(value:IValue) {
        for (let oldValue of this.values) {
            if (oldValue.row === value.row) {
                oldValue.choice = value.choice;
                return;
            }
        }

        this.values.push(value);
    }

    satisfiesValue(currentValues:IValue[], value:IValue):boolean {
        for (let currentValue of currentValues) {
            if (currentValue.row === value.row && currentValue.choice === value.choice) {
                return value.value;
            }
        }

        // value doesn't exists which means that it is false
        // if node wants it to be false then it satisfies logic
        return !value.value;
    }
}